export default __webpack_public_path__ + "static/media/wallet.7dffa2e1.png";